// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {enterAddHospitalEffect} from './enterAddHospital'

export const hospitalEffects = [
  enterAddHospitalEffect,
]
